<template>
	<a
		class="card card--no-gutter cms-list-item list-item grid-noGutter d-flex"
		:class="{ 'list-item--mounted': isMounted }"
		:href="data.link"
	>
		<div class="cms-list-item__left col-12_sm-5">
			<div
				class="cms-list-item__image"
				v-if="!showPattern"
				v-html="data.image"
			></div>
			<div class="cms-list-item__image" v-else v-html="Pattern"></div>
		</div>
		<div class="cms-list-item__right col-12_sm-7">
			<h3 class="cms-list-item__title header-extra-small">
				{{ data.title }}
			</h3>
			<span class="cms-list-item__description">
				{{ data.description }}
			</span>
			<span v-html="IconArrow"></span>
		</div>
	</a>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import IconArrow from "../../../../views/icons/arrow.cshtml";
import Pattern from "../../../../views/visuals/leafPatternLarge.cshtml";

const props = defineProps(['data', 'hideImages']);
const isMounted = ref(false);

const showPattern = computed(() => {
	return props.data.image.length === 0 || props.hideImages === "True";
});

onMounted(() => {
	setTimeout(() => {
		isMounted.value = true;
	}, 10);
});
</script>
